const tabs = {
  height: { default: 40 },

  borderWidth: { default: 2 },
}

export default tabs
